export default __webpack_public_path__ + "static/project-slide-4-1640-765-d01141c40cecbaf4c0a26d11a5d1f6c2.jpg";